/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElTree as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tree/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
import { byIdGetItem, byNameGetItem } from "@/util/index";
import { onMounted, reactive, watchEffect } from 'vue';
export default {
  __name: 'selectTree',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    target_list: {
      type: Array,
      default: []
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          children: "children",
          label: "name"
        };
      }
    },
    has_id: {
      type: String,
      default: "0"
    },
    width_: {
      type: String,
      default: ""
    },
    call_label: {
      type: String,
      default: ""
    }
  },
  emits: ["select_pid"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var selectTree = ref('');
    var tree = ref('');
    var emit = __emit;
    var props = __props;
    var data = reactive({
      value: "",
      current: {
        id: "",
        value: ""
      }
    });
    var init_show = () => {
      if (props.has_id && props.has_id != "0" && props.has_id != "undefined" && props.target_list.length != 0) {
        if (props.call_label) {
          var {
            id,
            value
          } = byNameGetItem(props.target_list, props.has_id, props.defaultProps.label);
          data.value = id;
          data.current = {
            id,
            value
          };
        } else {
          var {
            id: _id,
            value: _value
          } = byIdGetItem(props.target_list, props.has_id, props.defaultProps.label, props.defaultProps.children);
          data.value = _id;
          data.current = {
            id: _id,
            value: _value
          };
        }
      } else {
        data.value = "";
        data.current = {
          id: "",
          value: ""
        };
      }
    };
    onMounted(() => {
      init_show();
    });
    watchEffect(() => {
      if (props.has_id) {
        init_show();
      }
    });
    var handle_filter = query => {
      tree.value.filter(query);
    };
    var filterNode = (value, data, node) => {
      if (!value) return true;
      var parentNode = node.parent;
      var labels = [data[props.defaultProps.label || "name"].toLowerCase()];
      var level = 1;
      while (level < node.level) {
        labels = [...labels, parentNode.label.toLowerCase()];
        parentNode = parentNode.parent;
        level++;
      }
      return labels.some(label => label.indexOf(value.toLowerCase()) !== -1);
    };
    var handleNodeClick = data => {
      console.log("选择树形结构", data);
      data.value = data[props.defaultProps.label];
      data.current = {
        id: data.id,
        value: data[props.defaultProps.label]
      };
      // 使 input 失去焦点，并隐藏下拉框
      selectTree.value.blur();
      //触发父组件监听,传过去id,name
      if (props.call_label == "name") {
        emit("select_pid", data.current.value);
      } else {
        emit("select_pid", data.id);
      }
    };
    return (_ctx, _cache) => {
      var _component_el_option = __unplugin_components_0;
      var _component_el_tree = __unplugin_components_1;
      var _component_el_select = __unplugin_components_2;
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: data.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.value = $event),
        placeholder: props.placeholder,
        ref_key: "selectTree",
        ref: selectTree,
        style: _normalizeStyle({
          width: props.width_
        }),
        filterable: "",
        "filter-method": handle_filter,
        disabled: props.disabled
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_option, {
          key: data.current.id,
          value: data.current.id,
          label: data.current.value,
          hidden: ""
        }, null, 8, ["value", "label"])), _createVNode(_component_el_tree, {
          data: props.target_list,
          props: props.defaultProps,
          "node-key": "id",
          accordion: "",
          onNodeClick: handleNodeClick,
          "highlight-current": true,
          "expand-on-click-node": false,
          "filter-node-method": filterNode,
          ref_key: "tree",
          ref: tree
        }, null, 8, ["data", "props"])]),
        _: 1
      }, 8, ["modelValue", "placeholder", "style", "disabled"]);
    };
  }
};